module.exports =
  '_SETTING':
    'TITLE': 'Settings'
    'DISTANCE_UNIT': 'Distance Unit'
    'METER': 'Meter'
    'YARD': 'Yard'
    'EDIT_FRIEND': 'Register or Edit'
    'MEMBERSHIP': 'Membership'
    'LBL_SUBSCRIBE': 'Free Member'
    'SUBSCRIBE': 'Subscribe'
    'LBL_UNSUBSCRIBE': 'Paid Member'
    'UNSUBSCRIBE': 'Unsubscribe'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/setting/i18n/en.coffee